export default "__VITE_ASSET__CS7z_jIQ__"